import { Attachment } from 'shared_DEPRECATED/types/Attachment';

import { ChatMessageAttachment } from 'features/chat/components/ChatAttachment/ChatMessageAttachment';

import { isMediaFile } from 'shared/utils/mediaFile';

type ChatMessageUploadedAttachmentsProps = {
  attachments: Attachment[];
};

const ChatMessageUploadedAttachments = ({
  attachments,
}: ChatMessageUploadedAttachmentsProps) => {
  const onlyMedia = attachments.every((attachment: Attachment) =>
    isMediaFile(attachment.contentType)
  );

  return (
    <ChatMessageAttachment attachments={attachments} onlyMedia={onlyMedia} />
  );
};

export default ChatMessageUploadedAttachments;
